/**
 * NIGHTBOUND - The Pit (locked).
 *
 * Arena / PvP does not exist yet. The screen shows the creature's current
 * combat profile - the abilities and stats that the eventual fights will use -
 * so the readout is already meaningful.
 */

import { useGame } from '../state/GameProvider'
import { Link } from 'react-router-dom'
import { Chip, Panel, PanelHeading } from '../components/ui'
import { AbilityPanel, StatPanel } from '../components/panels'

const ROADMAP = [
  { title: 'Asynchronous duels', detail: 'Fight the recorded creatures of other players while they are away.' },
  { title: 'Turn order', detail: 'Speed decides who moves first. Status effects resolve each turn.' },
  { title: 'Seasons', detail: 'Ladders reset; the dark does not remember last season’s champion.' },
  { title: 'Essence stakes', detail: 'Winners take a fraction of the loser’s essence.' },
]

export function PitScreen() {
  const { creature } = useGame()

  return (
    <div className="mx-auto max-w-5xl px-4 py-6 sm:px-6">
      <header className="mb-5">
        <div className="flex items-center gap-3">
          <h1 className="font-display text-2xl text-bone-100">The Pit</h1>
          <Chip tone="warn">Locked</Chip>
        </div>
        <p className="mt-2 max-w-2xl text-sm leading-relaxed text-ash-400">
          Deep below the shelter, something has been arranged into a ring. Whatever gathers there
          does not care about your creature's feelings, only what it can survive. Combat is not
          built yet - but the abilities it will use already are.
        </p>
      </header>

      <div className="grid gap-5 lg:grid-cols-[1fr_20rem]">
        <div className="space-y-4">
          {creature ? (
            <>
              <StatPanel creature={creature} />
              <AbilityPanel creature={creature} />
            </>
          ) : (
            <Panel className="p-6 text-sm text-ash-400">
              Create a creature and its combat profile will appear here.
            </Panel>
          )}
        </div>

        <aside className="space-y-4">
          <Panel className="overflow-hidden">
            <PanelHeading>Not yet built</PanelHeading>
            <ul className="space-y-3 p-4">
              {ROADMAP.map((item) => (
                <li key={item.title} className="flex gap-3">
                  <span aria-hidden className="mt-1 text-ash-500">
                    ◆
                  </span>
                  <div>
                    <div className="text-xs font-semibold uppercase tracking-[0.12em] text-bone-300">
                      {item.title}
                    </div>
                    <p className="mt-0.5 text-[11px] leading-snug text-ash-400">{item.detail}</p>
                  </div>
                </li>
              ))}
            </ul>
          </Panel>
          <Link
            to="/shelter"
            className="inline-flex w-full items-center justify-center rounded-[3px] border border-ash-600 bg-night-700/70 px-4 py-2 text-xs font-semibold uppercase tracking-[0.14em] text-bone-300 transition-colors hover:bg-night-600"
          >
            Back to the shelter
          </Link>
        </aside>
      </div>
    </div>
  )
}
